module.exports = __webpack_public_path__ + "static/media/Proj3-choice.55144712.mp4";